// document.addEventListener("DOMContentLoaded", function () {
//   const canvas = document.getElementById("coverCanvas");
//   const ctx = canvas.getContext("2d");

//   const scaleFactor = 4;
//   const displayWidth = 600;
//   const displayHeight = 600;

//   canvas.width = displayWidth * scaleFactor;
//   canvas.height = displayHeight * scaleFactor;
//   canvas.style.width = displayWidth + "px";
//   canvas.style.height = displayHeight + "px";
//   ctx.scale(scaleFactor, scaleFactor);

//   const gender = localStorage.getItem("selectedGender") || "boy";
//   const coverImageUrl =
//     gender === "girl"
//       ? "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Cover_She.jpg?v=1744700184"
//       : "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Cover_He.jpg?v=1744700186";

//   const proxyUrl = `https://corsproxy.io/?${encodeURIComponent(coverImageUrl)}`;

//   const img = new Image();
//   img.crossOrigin = "anonymous"; // still good to have
//   img.src = proxyUrl;

//   img.onload = function () {
//     ctx.drawImage(img, 0, 0, displayWidth, displayHeight);

//     const childName = localStorage.getItem("childName") || "Your Name";
//     ctx.font = "56px 'Charis SIL'";
//     ctx.fillStyle = "#D2A32F";
//     ctx.textAlign = "center";
//     ctx.fillText(childName, displayWidth / 3.7, 246);
//   };
// });

document.addEventListener("DOMContentLoaded", async function () {
  const scaleFactor = 4.62;
  const originalWidth = 2783;

  const gender = (await loadProfile())?.gender || "BOY";
  const childName = (await loadProfile())?.name || "Your Name";

  const canvases = [
    {
      id: "coverCanvas", // Softcover
      imageUrl:
        gender === "GIRL"
          ? "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Softcover_She.png?v=1747387514"
          : "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Softcover_He.png?v=1747387866",
      textXDivider: 3.25,
      textYPosition: 262,
      originalHeight: 2822,
    },
    {
      id: "hardCoverCanvas", // Hardcover
      imageUrl:
        gender === "GIRL"
          ? "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Hardcover_She.png?v=1747378982"
          : "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Hardcover_He.png?v=1747387724",
      textXDivider: 3.6,
      textYPosition: 278,
      originalHeight: 3024,
    },
  ];

  canvases.forEach(
    ({ id, imageUrl, textXDivider, textYPosition, originalHeight }) => {
      const canvas = document.getElementById(id);
      if (!canvas) return;
      const ctx = canvas.getContext("2d");

      const displayWidth = originalWidth / scaleFactor;
      const displayHeight = originalHeight / scaleFactor;

      canvas.width = originalWidth;
      canvas.height = originalHeight;

      // Set visible display size (scaled down)
      canvas.style.width = `${displayWidth}px`;
      canvas.style.height = "auto"; // Maintain aspect ratio

      ctx.scale(scaleFactor, scaleFactor);

      // const proxyUrl = `https://corsproxy.io/?${encodeURIComponent(imageUrl)}`;
      const proxyUrl = imageUrl;
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = proxyUrl;

      img.onload = function () {
        ctx.drawImage(img, 0, 0, displayWidth, displayHeight);
        ctx.font = "56px 'Charis SIL'";
        ctx.fillStyle = "#D2A32F";
        ctx.textAlign = "center";
        ctx.fillText(childName, displayWidth / textXDivider, textYPosition);
      };
    }
  );
});
